module.exports = __webpack_public_path__ + "assets/media/lift-ai-logo.9e735054.png";